import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig } from '@ng-dynamic-forms/core';
import { PageBuilderItem } from '../page-builder-components.models';

export interface PageBuilderDatasourcesModelConfig extends DynamicInputModelConfig {
    datasources: any[];
}

export class PageBuilderDatasourcesModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_datasources'; 
	datasources: any[];

	constructor(config: PageBuilderDatasourcesModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.datasources = config.datasources;
	}

	static initModel(_component: PageBuilderItem): PageBuilderDatasourcesModel { 
		const formModel = new PageBuilderDatasourcesModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE,
            datasources: _component.DATASOURCES,
		});
		return formModel;
	}
}